import React from 'react'
import { Box, Text, Button } from '@usap/uicomponents'

const ImgErrorMessageLb = ({
  imgErrorMessage,
  setDisplayImgUploadError,
}) => (
  <Box
    fadeIn
    style={{
      padding: 16,
      width: '400px',
      backgroundColor: '#FFF',
      alignSelf: 'center',
    }}
  >
    <Text
      size="small"
      margin={{ bottom: '20px', top: '20px' }}
      alignSelf="center"
      style={{ fontWeight: '500' }}
    >
      {imgErrorMessage}
    </Text>
    <Button
      onClick={() => setDisplayImgUploadError(false)}
      type="submit"
      style={{ fontSize: 14, color: '#DB2429', fontWeight: 'bold' }}
      color="#DB2429"
      hideBorder
      size="small"
      label="OK"
    />
  </Box>
)

export default ImgErrorMessageLb
